import React from "react";
import type {VoidFunctionComponent} from "react";
import {useDashboardUserCurrentLevelLogic} from "./DashboardUserCurrentLevel.logic";
import {UserSummaryStatsContainer} from "../../../components/dashboard/user-stats-container/UserSummaryStatsContainer";

export const DashboardUserCurrentLevel: VoidFunctionComponent = () => {
  const {currentLevel} = useDashboardUserCurrentLevelLogic();
  return <UserSummaryStatsContainer value={currentLevel ?? 0} label={`Current level`} />;
}
